import { colors } from 'components/styles/variables';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import chevronDown from 'public/static/images/chevron-down.svg';

export default function ToggleExpandedButton({
  isExpanded,
  className = '',
  ...otherProps
}) {
  const { t } = useTranslation();

  return (
    <button
      {...otherProps}
      className={`${className} ${isExpanded && 'expanded'}`}
      data-testid="toggle-expanded"
    >
      {isExpanded ? t('dealerPages.readLess') : t('dealerPages.readMore')}
      <style jsx>{`
        button {
          align-self: flex-end;
          display: block;
          padding: 0;
          margin: 0;
          background-color: white;
          border: none;
          font-weight: 900;
          text-transform: uppercase;
          height: 23px;
          padding-right: 23px;
          cursor: pointer;
          color: ${colors.G4};
        }

        button:after {
          background-image: url(${chevronDown});
          position: absolute;
          content: '';
          height: 23px;
          width: 23px;
        }

        .expanded:after {
          transform: rotate(180deg);
        }

        button:hover {
          color: ${colors.BLACK};
        }
      `}</style>
    </button>
  );
}

ToggleExpandedButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  isExpanded: PropTypes.bool.isRequired,
};
